import { closeAllItems } from 'src/all-items/all-items';
import { AbortedError } from 'src/common/api/extended-emerald-error';
import { restorePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { isNumber } from 'src/common/helpers/number-helper';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { IItemInputData } from 'src/common/interfaces/IItemInputData';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { closeSearchModal } from 'src/search/search';
import { showManualVolumeWindow } from '../components/manual-volume';

export const getManualVolume = async (
  itemLookup: IItemLookup,
  inputData?: IItemInputData,
): Promise<number> => {
  // close possible modal other than from the main add item flow
  closeAllItems();
  closeSearchModal();
  return new Promise<number>((resolve, reject) => {
    const onKeypadSubmit = async (input: string): Promise<void> => {
      if (isNumber(input) && Number(input)) {
        if (inputData && inputData.manualQuantity && inputData.manualQuantity < parseFloat(input)) {
          popupMessage({
            message: 'TbrQuantityExceedsMaxAllowedException',
            type: EmeraldDialogTypes.Error,
            onAccept: () => {},
            acceptButtonLabel: 'close',
            disableBackdropClick: true,
          });
        } else {
          resolve(Number(input));
        }
      } else {
        popupMessage({
          message: 'ManualVolume_InvalidVolume',
          type: EmeraldDialogTypes.Error,
          subMessage: 'ManualVolume_RetryMessage',
          onAccept: () => {},
          onCancel: onCancel,
          acceptButtonLabel: 'ManualVolume_Retry',
          closeButtonLabel: 'Cancel_Button',
          disableBackdropClick: true,
        });
      }
    };
    const onCancel = () => {
      reject(new AbortedError());
    };

    showManualVolumeWindow({ onKeypadSubmit, onCancel, itemLookup, inputData });
  }).finally(() => restorePage());
};
